"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmptyString;
/**
 * @param {*} value
 * @returns {boolean}
 */
function isEmptyString(value) {
  return value === '';
}
//# sourceMappingURL=is-empty-string.js.map